import { render, staticRenderFns } from "./EventClose.vue?vue&type=template&id=a787c93e&scoped=true"
import script from "./EventClose.vue?vue&type=script&lang=ts"
export * from "./EventClose.vue?vue&type=script&lang=ts"
import style0 from "./EventClose.vue?vue&type=style&index=0&id=a787c93e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a787c93e",
  null
  
)

export default component.exports